import { brandsMasterDataApi, competitionGroupsMasterDataApi, competitionsMasterDataApi, gendersMasterDataApi, productCategoriesMasterDataApi, productClassesMasterDataApi, productGroupsMasterDataApi, productSizesMasterDataApi, productsMasterDataApi, sportsMasterDataApi, teamGroupsMasterDataApi, teamsMasterDataApi, versionsMasterDataApi } from "@/apis/apis";
import { PRODUCT_GROUPS } from "@/constant/constants";

export const BASE_IMPORT_DATA = {
    BASE_PRODUCT_PRODUCT_GROUP: {
        [PRODUCT_GROUPS.JERSEYS]: {
            dataName: "Base Product - Product Group: Jerseys",
            shouldUniqueColumn: "Base Product ID",
            shouldBeUniqueCompositeColumns: [
                "Sport ID",
                "Product ID",
                "Team ID",
                "Term ID",
                "Edition ID",
                "Brand ID"
            ],
            columns: [
                "Base Product ID",
                "Sport ID",
                "Product ID",
                "Team ID",
                "Term ID",
                "Edition ID",
                "Brand ID"
            ],
        },
        [PRODUCT_GROUPS.TEAM_MERCHANDISE]: {
            dataName: "Base Product - Product Group: Team Merchandise",
            shouldUniqueColumn: "Base Product ID",
            shouldBeUniqueCompositeColumns: [
                "Sport ID",
                "Product ID",
                "Team ID",
            ],
            columns: [
                "Base Product ID",
                "Sport ID",
                "Product ID",
                "Team ID",
            ],
        },
        [PRODUCT_GROUPS.MATCH_BALLS]: {
            dataName: "Base Product - Product Group: Match Balls",
            shouldUniqueColumn: "Base Product ID",
            shouldBeUniqueCompositeColumns: [
                "Sport ID",
                "Product ID",
                "Competition ID",
                "Term ID",
                "Edition ID",
            ],
            columns: [
                "Base Product ID",
                "Sport ID",
                "Product ID",
                "Competition ID",
                "Term ID",
                "Edition ID",
            ],
        },
    },
    TEAM_GROUP_TEAM: {
        dataName: "Team Group - Team",
        shouldExistColumns: {
            [teamGroupsMasterDataApi]: "Team Group ID",
            [teamsMasterDataApi]: "Team ID",
        },
        columns: ["Team Group ID", "Team ID"],
        enableAddMode: false,
    },
    COMPETITION_GROUP_COMPETITION: {
        dataName: "Competition Group - Competition",
        shouldExistColumns: {
            [competitionGroupsMasterDataApi]: "Competition Group ID",
            [competitionsMasterDataApi]: "Competition ID",
        },
        columns: ["Competition Group ID", "Competition ID"],
        enableAddMode: false,
    },
    SPORT_GROUP_CATEGORY_PRODUCT: {
        dataName: "Sport - Group - Category - Product",
        shouldBeUniqueCompositeColumns: [
            "Sport ID",
            "Product Group ID",
            "Parent Product Category ID",
            "Product Category ID",
            "Product ID",
        ],
        shouldExistColumns: {
            [sportsMasterDataApi]: "Sport ID",
            [productGroupsMasterDataApi]: "Product Group ID",
            ['admin/parent-product-categories']: "Parent Product Category ID",
            [productCategoriesMasterDataApi]: "Product Category ID",
            [productsMasterDataApi]: "Product ID",
        },
        nullableColumns: ["Parent Product Category ID", "Product Category ID"],
        columns: ["Sport ID", "Product Group ID", "Parent Product Category ID", "Product Category ID", "Product ID"],
        enableAddMode: false,
    },
    PRODUCT_GENDER_SIZE: {
        dataName: "Product - Gender - Size",
        shouldExistColumns: {
            [productsMasterDataApi]: "Product ID",
            [gendersMasterDataApi]: "Gender ID",
            [productSizesMasterDataApi]: "Size ID",
        },
        columns: ["Product ID", "Gender ID", "Size ID"],
        enableAddMode: false,
    },
    PRODUCT_BRAND: {
        dataName: "Product - Brand",
        shouldExistColumns: {
            [productsMasterDataApi]: "Product ID",
            [brandsMasterDataApi]: "Brand ID",
        },
        columns: ["Product ID", "Brand ID"],
        enableAddMode: false,
    },
    PRODUCT_VERSION: {
        dataName: "Product - Version",
        shouldExistColumns: {
            [productsMasterDataApi]: "Product ID",
            [versionsMasterDataApi]: "Version ID",
        },
        columns: ["Product ID", "Version ID"],
        enableAddMode: false,
    },
    PRODUCT_CLASS_PRODUCT: {
        dataName: "Product Class-Product",
        shouldExistColumns: {
            [productClassesMasterDataApi]: "Product Class ID",
            [productsMasterDataApi]: "Product ID",
        },
        columns: ["Product Class ID", "Product ID"],
        enableAddMode: false,
    },
};

